import "./formButton.scss";

import PropTypes from "prop-types";
import React from "react";

import keyConstants from "../../constants/keyConstants";
import { PropTypeShapes } from "../../types";

const FormListButtonWrapper = ({ children, className, onClick, ...otherProps }) => {
  const onKeyDown = e => {
    if (e.key === keyConstants.Enter && onClick) {
      e.stopPropagation();
      e.preventDefault();
      onClick(e);
    }
  };

  const classes = [className, "formListButtonWrapper"];

  return (
    <div
      className={classes.join(" ")}
      onClick={onClick}
      tabIndex={onClick ? 0 : null}
      onKeyDown={onKeyDown}
      {...otherProps}
    >
      {children}
    </div>
  );
};

FormListButtonWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypeShapes.elementOrArray,
  onClick: PropTypes.func
};

export default FormListButtonWrapper;
